export enum DisplayState {
  SUCCESS = 'Success',
  WARNING = 'Warning',
  ERROR = 'Error'
}
